var _ = require('underscore');
var AccordionWidget = require('./../widget/accordion/AccordionWidget');
var estimatedBillTemplate = require('./estimatedBillTemplate.hbs');
var financialFeatureConfigModel = require('./../financial/financialFeatureConfigModel');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');
var SecureMessageDataBehavior = require('./../secure-message/SecureMessageDataBehavior');
var InsuranceEstimationDataBehavior = require('./InsuranceEstimationDataBehavior');

require('jquery');
require('./../../target/node_modules/vecna-javascript/jquery.print');

/**
 * Displays estimated bill
 *
 * @class EstimatedBillWidget
 * @extends Torso.View
 * @constructor
 * @param options {Object}
 *   @param options.appointmentExternalId {String} the external id of the appointment to get the estimate (via account) for.
 */
module.exports = AccordionWidget.extend({
  template: estimatedBillTemplate,

  accordionId: 'estimated-bill-accordion',
  noTriggerView: true,
  noContentView: true,

  behaviors: {
    appointment: {
      behavior: SecureMessageDataBehavior,
      alwaysFetch: true,
      returnSingleResult: true,
      ids: function(cache) {
        var criteria = {
          isPatient: true,
          appointmentCriteria: {
            externalAppointmentCriteria: {
              externalIds: [this.view._appointmentExternalId]
            }
          }
        };
        return cache.fetchIdsByCriteria(criteria);
      }
    },
    appointmentSecureMessages: {
      behavior: SecureMessageDataBehavior,
      updateEvents: ['behaviors.appointment:fetched'],
      alwaysFetch: true,
      ids: function(cache) {
        var accountExternalId = this.view.getBehavior('appointment').data.get('appointmentDTO.accountExternalId');
        if (_.isUndefined(accountExternalId)) {
          return [];
        }
        var criteria = {
          isPatient: true,
          appointmentCriteria: {
            externalAppointmentCriteria: {
              accountNumbers: [accountExternalId]
            }
          }
        };
        return cache.fetchIdsByCriteria(criteria);
      }
    },
    insuranceEstimation: {
      behavior: InsuranceEstimationDataBehavior,
      returnSingleResult: true,
      alwaysFetch: true,
      renderOnFetch: true,
      updateEvents: ['behaviors.appointment:fetched', 'view.financialConfigLoaded:change'],
      ids: function() {
        var accountExternalId = this.view.getBehavior('appointment').data.get('appointmentDTO.accountExternalId');
        var isEstimatedCostEnabled = financialFeatureConfigModel.isEstimatedCostEnabled(financialFeatureConfigModel.CONFIG_LEVEL.NORMAL);
        if (accountExternalId && isEstimatedCostEnabled) {
          return accountExternalId;
        }
      }
    },
    appointmentTypes: {
      behavior: AppointmentTypeDataBehavior,
      renderOnFetch: true,
      ids: { property: 'behaviors.appointmentSecureMessages.data:appointmentDTO.externalAppointment.type'}
    }
  },

  events: _.defaults({
    'click .secondary-link--print': '_print'
  }, AccordionWidget.prototype.events),

  prepareFields: _.defaults({
    negativeInsuranceAdjustment: function() {
      var insuranceEstimation = this.getBehavior('insuranceEstimation').data.getModel();
      return insuranceEstimation && insuranceEstimation.getNegativeInsuranceAdjustment();
    },
    negativeInsurancePayment: function() {
      var insuranceEstimation = this.getBehavior('insuranceEstimation').data.getModel();
      return insuranceEstimation && insuranceEstimation.getNegativeInsurancePayment();
    },
    hasUnapprovedUpdates: 'hasUnapprovedUpdates',
    isOnAppointmentDetails: '_isOnAppointmentDetails',
    loading: '_isLoading',
    showContent: 'isLoadingOrHasEstimate'
  }, AccordionWidget.prototype.prepareFields),

  /**
   * @method getTotalCharges
   * @returns {Number} the total cost for the patient for this estimate.
   */
  getTotalCharges: function() {
    var insuranceEstimationTotalCostString = this.getBehavior('insuranceEstimation').data.get('remainingBalance');
    var insuranceEstimationTotalCost = insuranceEstimationTotalCostString && parseFloat(insuranceEstimationTotalCostString);
    return insuranceEstimationTotalCost || 0;
  },

  /**
   * @method isLoadingOrHasEstimate
   * @return {boolean}
   */
  isLoadingOrHasEstimate: function() {
    var isLoading = this._isLoading();
    var hasInsuranceEstimation = this.hasEstimate();
    return isLoading || hasInsuranceEstimation;
  },

  /**
   * @method hasEstimate
   * @return {Boolean} true if the fetched estimated bill exists, false otherwise.
   */
  hasEstimate: function() {
    return !!this.getBehavior('insuranceEstimation').data.get('insuranceEstimation');
  },

  /**
   * @method hasUnapprovedUpdates
   * @return {Boolean} true if the are outstanding updates on the insurance that need to be approved, false otherwise.
   */
  hasUnapprovedUpdates: function() {
    return this.getBehavior('insuranceEstimation').data.get('hasUnapprovedInsuranceUpdates');
  },

  /**
   * @method initialize
   * @override
   * @param options {Object}
   *   @param options.appointmentExternalId {String} the external id of the appointment to get the estimate (via account) for.
   *   @param options.visitId {String} the id of the visit to use to get the insurances for this appointment.
   */
  initialize: function(options) {
    _.bindAll(this, '_print', '_setFinancialConfigLoaded', '_triggerEstimateUpdated');

    var view = this;
    options = options || {};
    this._appointmentExternalId = options.appointmentExternalId;
    this._visitId = options.visitId;

    var insuranceEstimationBehavior = this.getBehavior('insuranceEstimation');
    this.listenTo(insuranceEstimationBehavior, 'fetched', function() {
      view.trigger('change:totalCharges');
    });
    this.listenTo(insuranceEstimationBehavior, 'fetched', this._triggerEstimateUpdated);

    financialFeatureConfigModel.loadOnce()
      .then(this._setFinancialConfigLoaded)
      .then(this._triggerEstimateUpdated);
  },

  _triggerEstimateUpdated: function() {
    this.trigger('estimate-updated');
  },

 /**
  * @method prerender
  * @override
  */
  prerender: function() {
    var showEstimateDetails = this.hasEstimate() && !this.hasUnapprovedUpdates();
    if (showEstimateDetails) {
      this._setAttributes({
        'class': this.className + ' brec-list__item--accordion'
      });
    }
  },

  /**
   * Marks that the financial feature config has finished loading
   * @method setFinancialConfigLoaded
   * @private
   */
  _setFinancialConfigLoaded: function() {
    this.set('financialConfigLoaded', true);
  },

  /**
   * @method _shouldShowDetails
   * @return {boolean} only show details if there are no unapproved insurance updates.
   * @private
   */
  _shouldShowDetails: function() {
    return !this.hasUnapprovedUpdates();
  },

  /**
   *
   * @return {boolean|*|true}
   * @private
   */
  _isLoading: function() {
    var financialConfigLoaded = this.get('financialConfigLoaded');

    var appointmentBehavior = this.getBehavior('appointment');
    var appointmentLoading = appointmentBehavior.isLoading();

    var appointmentSecureMessagesBehavior = this.getBehavior('appointmentSecureMessages');
    var appointmentSecureMessagesLoading = appointmentSecureMessagesBehavior.isLoading();

    var insuranceEstimationBehavior = this.getBehavior('insuranceEstimation');
    var insuranceEstimationLoading = insuranceEstimationBehavior.isLoading();


    var appointmentTypesBehavior = this.getBehavior('appointmentTypes');
    var appointmentTypesLoading = appointmentTypesBehavior.isLoading();

    return !financialConfigLoaded || appointmentLoading || appointmentSecureMessagesLoading
      || insuranceEstimationLoading || appointmentTypesLoading;
  },

  /**
   * Prints this view.
   * @method _print
   * @param event {jQuery.Event} the event that triggered this call to print.
   * @private
   */
  _print: function(event) {
    event.preventDefault();
    this.$el.print();
    return false;
  }
});
